// PiMicrosoftExcelLogoFill
import Button from '../atoms/Button';
import { PiMicrosoftExcelLogoFill } from 'react-icons/pi';
//import { useSelector, useDispatch } from 'react-redux';
//import { saveUserLog } from '../../utils/saveUserLog';
import i18n from '../../utils/i18n';
import { useTranslation } from 'react-i18next';
import { translateText } from '../../utils/translateText';

const SearchButton = ({ onClick, style, label }) => {
  const { t } = useTranslation();
  const language = i18n.language;
 // const dispatch = useDispatch();
  // const search_btn_page = useSelector(
  //   (state) => state.globalState.currentPageTitle
  // );
  // const user = useSelector((state) => state.userState.user);
  // const brand = useSelector((state) => state.globalState.brand);
  // const brdCd = useSelector((state) => state.globalState.brdCd);
  // const user_info = user.name;
  // const email = user.username;
  // const paraSet = {
  //   user_info: `'${user_info}'`,
  //   email: `'${email}'`,
  //   page_nm: null,
  //   search_btn_page: `'${search_btn_page}'`,
  //   excel_btn_page: null,
  //   brd_cd: `'${brdCd}'`,
  //   brd_nm: `'${brand}'`,
  // };
  return (
    <Button
      onClick={onClick}
      label={
        <span style={{ display: 'flex', alignItems: 'center' }}>{translateText({text: label, globalLanguage: language})}</span>
      }
      mode="primary"
      variant="content1"
      style={{
        boxShadow: '0 2px 2px rgba(0,0,0,0.1)',
        padding: '5px 20px',
        borderRadius: '5px',
        margin: '0 2px',
        minWidth: '75px',
        ...style,
      }}
    />
  );
};

export default SearchButton;
